<template>
  <div id="Home" ref="Home" @click="isDo">
    <header>
      <!--  <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;">
                <el-radio-button :label="false">展开</el-radio-button>
                <el-radio-button :label="true">收起</el-radio-button>
            </el-radio-group> -->
      <!-- <img src="https://d.n2car.com/DikaluBss/BSSNewStyle/media/image/logo.png" alt="" class="logo"> -->
      <div class="logo" style="color:#fff;font-weight:bolder;cursor:default;">
        <span style="float:left;margin-top:28px;font-size:20px;line-height:1"
          >纳琳科质保管理总后台</span
        >
      </div>
      <div class="app-header-userinfo">
        <el-dropdown trigger="hover" :hide-on-click="false">
          <span class="el-dropdown-link user">
            <!-- <img
              src="https://nkdpdi.nkodapu.com/pdi/BSSNewStyle/media/image/IndexHeadPortrait.jpg"
              alt=""
            /> -->
            <p>{{ username }}</p>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item @click.native="set">修改密码</el-dropdown-item> -->
            <el-dropdown-item @click.native="logout"
              >退出登录</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </header>
    <section>
      <nav :style="isShow ? 'width:20vw' : 'width:56px'">
        <ul>
          <router-link
            :to="item.path"
            tag="li"
            v-for="(item, Home) in navList"
            :key="Home"
            :title="!isShow ? item.name : ''"
          >
            <i :class="item.icon"></i>
            <span v-if="isShow">{{ item.text }}</span>
          </router-link>
        </ul>
      </nav>
      <router-view class="content"></router-view>
    </section>
    <el-dialog
      title="修改密码"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        status-icon
        label-width="100px"
        ref="editForm"
        :rules="rules"
      >
        <el-form-item label="原密码：" prop="ymm">
          <el-input
            type="password"
            v-model="editForm.ymm"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="xmm">
          <el-input
            type="password"
            v-model="editForm.xmm"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="qrmm">
          <el-input
            type="password"
            v-model="editForm.qrmm"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancel('editForm')">取消</el-button>
        <el-button type="primary" @click.native="handleUpdate('editForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import allRoute from "./../router/route";

import { getADMIN } from "./../axios/api";
export default {
  name: "Home",
  data() {
    var validatePass1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输新入密码"));
      } else {
        if (this.editForm.qrmm !== "") {
          this.$refs.editForm.validateField("qrmm");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.editForm.xmm) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      username: "",
      editFormVisible: false, //弹框
      editForm: {}, //弹框数据
      rules: {
        ymm: [{ required: true, message: "请输入原密码", trigger: "blur" }],
        xmm: [{ required: true, validator: validatePass1, trigger: "blur" }],
        qrmm: [{ required: true, validator: validatePass2, trigger: "change" }]
      },
      navList: [],
      isShow: true,
      // isCollapse:false
      lastTime2: null, //最后一次点击的时间
      currentTime2: null, //当前点击的时间
      timeOut: 300 * 60 * 1000, //设置超时时间：十分钟
      timer: null
    };
  },
  methods: {
    size: function() {
      if (this.$refs.Home.clientWidth < 1198) {
        this.isShow = false;
        // this.isCollapse=true
      } else {
        this.isShow = true;
        // this.isCollapse=false
      }
    },
    set: function() {
      this.editFormVisible = true; //显示弹框
    },
    //点击关闭dialog
    handleClose(done) {
      this.editFormVisible = false;
      this.editForm = {};
      this.$refs["editForm"].clearValidate();
    },
    //点击取消
    handleCancel(formName) {
      this.editFormVisible = false;
      this.editForm = {};
      this.$refs["editForm"].clearValidate();
    },
    //点击更新
    handleUpdate(forName) {
      //更新的时候就把弹出来的表单中的数据写到要修改的表格中
      var _this = this;
      this.$refs["editForm"].validate(valid => {
        if (valid) {
          var data = {
            UserAccount: localStorage.getItem("username2"),
            OldPassword: _this.editForm.ymm,
            NewPassword: _this.editForm.xmm
          };

          getADMIN
            .set(data)
            .then(function(res) {
              _this.editFormVisible = false;
              _this.editForm = {};
              _this.$refs["editForm"].clearValidate();
              _this.$alert("修改成功!", "提示", {
                confirmButtonText: "确定"
              });
            })
            .catch(function(res) {
              _this.editFormVisible = false;
              _this.editForm = {};
              _this.$refs["editForm"].clearValidate();
              // console.log(res)
              _this.$alert(res, "提示", {
                confirmButtonText: "确定"
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    logout: function() {
      localStorage.removeItem("token2");
      localStorage.removeItem("token2");
      localStorage.removeItem("username2");
      localStorage.removeItem("lastTime2");
      localStorage.removeItem("currentTime2");
      localStorage.removeItem("route2");
      this.$router.push({ path: "/login" });
    },
    isDo() {
      localStorage.setItem("currentTime2", new Date().getTime());
      if (
        localStorage.getItem("currentTime2") -
          localStorage.getItem("lastTime2") >
        this.timeOut
      ) {
        //判断上次最后一次点击的时间和这次点击的时间间隔是否大于15分钟
        // 这里写状态已过期后执行的操作
        clearTimeout(this.timer);
        localStorage.removeItem("token2");
        localStorage.removeItem("username2");
        localStorage.removeItem("lastTime2");
        localStorage.removeItem("currentTime2");
        localStorage.removeItem("route2");
      } else {
        localStorage.setItem("lastTime2", new Date().getTime());
        clearTimeout(this.timer);
        this.timer = setTimeout(function() {
          localStorage.removeItem("token2");
          localStorage.removeItem("username2");
          localStorage.removeItem("lastTime2");
          localStorage.removeItem("currentTime2");
          localStorage.removeItem("route2");
        }, this.timeOut);
      }
    }
  },
  mounted() {
    var route;
    try {
      route = localStorage.getItem("route2").split(",");
    } catch (error) {
      route = [];
    }
    // console.log(route,allRoute)
    var arr = [];
    allRoute.map(item => {
      if (route.indexOf(item.name) != -1) {
        // console.log(item)
        arr.push(item);
      }
    });
    this.navList = arr;

    this.size();
    window.onresize = () => {
      this.size();
    };
    this.username = localStorage.getItem("username2");
    if (!localStorage.getItem("lastTime2")) {
      localStorage.setItem("lastTime2", new Date().getTime());
      this.isDo();
    } else {
      this.isDo();
    }
  },
  //离开当前页面后执行
  destroyed: function() {
    window.onresize = () => {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#Home {
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
header {
  position: absolute;
  background: rgb(38, 47, 64);
  box-shadow: 2px 1px 10px 2px rgb(25, 29, 37);
  width: 100%;
  min-width: 1056px;
  height: 70px;
  display: flex;
  justify-content: space-between;
  padding: 0 50px;
  box-sizing: border-box;
  align-items: center;
}
#Home .app-header-userinfo {
  float: right;
  cursor: pointer;
}
#Home .user {
  display: flex;
  align-items: center;
}
#Home .user p {
  margin-left: 20px;
}
.el-radio-group {
  margin: 0 !important;
  margin-left: 20px !important;
}
section {
  flex: 1;
  box-sizing: border-box;
  padding-top: 70px;
  height: 100%;
  min-height: 950px;
  display: flex;
}
nav {
  min-width: 56px;
  max-width: 300px;
  padding: 30px 0;
  box-sizing: border-box;
  background: rgb(38, 47, 64);
}
nav > ul li {
  padding: 20px;
}
nav > ul li i {
  display: inline-block;
  margin: 0 auto;
  color: #99a6bf;
}
nav > ul li span {
  color: #99a6bf;
  display: inline-block;
}
nav > ul li:hover {
  cursor: pointer;
  background: rgb(0, 217, 199);
}
nav > ul li:hover i {
  color: #fff;
}
nav > ul li:hover span {
  color: #fff;
}
.router-link-active {
  background: rgb(0, 217, 199);
}
.router-link-active i {
  color: #fff;
}
.router-link-active span {
  color: #fff;
}
#Home .content {
  flex: 1;
  min-width: 1000px;
  background: rgb(28, 36, 51);
  padding: 20px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/page/Home.vue